export default __webpack_public_path__ + "static/media/887.1e30ea10.png";